 // mediaManagment/audioSlideshow_types

import { Media            ,
         initializedMedia } from './types';

export interface AudioSlideshow extends Media
 {
  visible                            : string ,
  title                              : string ,
  description                        : string ,
  imageDisplayDuration               : string ,
  soundPlayingDuration               : string ,
  soundPlayingLoopMode               : boolean ,
  soundStartTimecodeInAudioSlideshow : string ,
  soundStartTimecodeInSoundFile      : string ,
  image_id                           : number ,
  sound_id                           : number ,
  videoFile                          : string
 }

export const initializedAudioSlideshow = (): AudioSlideshow => (
 {
  ...initializedMedia()                       ,
  visible                            : "" ,
  title                              : "" ,
  description                        : "" ,
  imageDisplayDuration               : "" ,
  soundPlayingDuration               : "" ,
  soundPlayingLoopMode               : false ,
  soundStartTimecodeInAudioSlideshow : "" ,
  soundStartTimecodeInSoundFile      : "" ,
  image_id                           : 0  ,
  sound_id                           : 0  ,
  videoFile                          : "" ,
});
